import './chatBotDataTable.css';

const ChatBotDataTable = ({ data, loading, onEdit, setDeleteItem }) => {
    if (loading) {
        return <div className='cbd-table-loading'>Loading...</div>;
    }

    return (
        <div className='cbd-table-wrapper'>
            <table className='cbd-table'>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Type</th>
                        <th>Aliases</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                </thead>

                <tbody>
                    {data.length === 0 ? (
                        <tr>
                            <td colSpan='5' className='cbd-no-data'>
                                No chatbot data found.
                            </td>
                        </tr>
                    ) : (
                        data.map((item) => (
                            <tr key={item._id}>
                                <td>{item.name}</td>

                                <td>{item.type}</td>

                                <td>
                                    {item.aliases?.length ? (
                                        <div className='cbd-aliases'>
                                            {item.aliases.map((alias, index) => (
                                                <div key={index} className='cbd-alias'>
                                                    {alias}
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        '-'
                                    )}
                                </td>

                                <td>{item.isActive ? 'Active' : 'Inactive'}</td>

                                <td className='cbd-action-btns'>
                                    <button className='cbd-edit-btn' onClick={() => onEdit(item)}>
                                        Edit
                                    </button>

                                    <button className='cbd-delete-btn' onClick={() => setDeleteItem(item)}>
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default ChatBotDataTable;
